import Vue from 'vue';
import Router from 'vue-router';

import HomePage from '@/components/HomePage';
import ContactPage from "@/components/ContactPage";
import SupportPage from "@/components/SupportPage";

Vue.use(Router);

export default new Router({
    mode: 'history',
    routes: [
        { path: '/', component: HomePage },
        { path: '/contact', component: ContactPage },
        { path: '/support', component: SupportPage, meta: { title: 'Support' }},
        { path: '*', redirect: '/' }
    ]
});